import {
  cn,
  composeRefs,
  nanoid
} from "./chunk-LJ5F4WFH.js";

// src/Form/FormField.tsx
import React, { useCallback, useContext, useState } from "react";
function useFormFieldProvider(props) {
  const generatedID = nanoid();
  const { id: idProp, disabled, invalid, readOnly, ...htmlProps } = props;
  const id = idProp || `formfield-${generatedID}`;
  const labelID = `${id}-label`;
  const messageID = `${id}-message`;
  const [hasMessage, setHasMessage] = useState(false);
  const getRootProps = useCallback(
    (rootProps = {}, forwardedRef = null) => ({
      ...rootProps,
      ...htmlProps,
      ref: forwardedRef,
      "aria-disabled": !!disabled
    }),
    [htmlProps, disabled]
  );
  const getLabelProps = useCallback(
    (labelProps = {}, forwardedRef = null) => ({
      ...labelProps,
      ref: forwardedRef,
      id: labelProps.id !== void 0 ? labelProps.id : labelID,
      htmlFor: labelProps.htmlFor !== void 0 ? labelProps.htmlFor : id
    }),
    [id, labelID]
  );
  const getMessageProps = useCallback(
    (messageProps = {}, forwardedRef = null) => ({
      id: messageID,
      ...messageProps,
      ref: composeRefs(forwardedRef, (node) => {
        if (!node) return;
        setHasMessage(true);
      })
    }),
    [messageID]
  );
  return {
    id,
    disabled,
    invalid,
    labelID,
    messageID,
    getRootProps,
    getLabelProps,
    hasMessage,
    getMessageProps,
    readOnly
  };
}
var FormFieldContext = React.createContext(
  {}
);
function useFormFieldContext() {
  return useContext(FormFieldContext);
}
function useFormField(props = {}) {
  const field = useFormFieldContext();
  return {
    ...props,
    id: props?.id ?? field?.id,
    "aria-describedby": field?.messageID || void 0,
    disabled: field?.disabled ?? props?.disabled,
    "aria-invalid": props["aria-invalid"] || !!field?.invalid,
    readOnly: field?.readOnly ?? props?.readOnly
  };
}
var FormField = ({
  children,
  className,
  ...props
}) => {
  const { getRootProps, ...context } = useFormFieldProvider(props);
  return /* @__PURE__ */ React.createElement(FormFieldContext.Provider, { value: context }, /* @__PURE__ */ React.createElement(
    "div",
    {
      ...getRootProps(),
      className: cn("flex flex-col gap-1 text-left", className)
    },
    children
  ));
};

export {
  useFormFieldContext,
  useFormField,
  FormField
};
//# sourceMappingURL=chunk-MJ3U6SP3.js.map